import React from "react";
import UpdateSchedulePayment from "components/makePayment/UpdateSchedulePayment";
import DisclosureInitial from "components/makePayment/DisclosureInitial";
import { SettingsValue } from "types/payments";
import { useTid } from "utils/testid";
import { PaymentMethodSelection } from "utils/updatePaymentPlanUtils";

interface UpdatePlanContentProps {
  initialDisclosureAccept: boolean;
  generalMarkers: any;
  onDisclosureAccept: () => void;
  portalSettings: any;
  // UpdateSchedulePayment props
  planId: string;
  values: any;
  isUpdateLoading: boolean;
  isUpdateRetryLoading: boolean;
  setValues: any;
  currentStep: number;
  selectedMethod: string;
  setSelectedMethod: (method: string) => void;
  completedSteps: [];
  setIsStartDate: (value: boolean) => void;
  data: any;
  setData: any;
  isStartDate: boolean;
  setIsApiCall: (value: boolean) => void;
  handleDebouncedChange: () => void;
  handleSave: () => void;
  dataPayment: any;
  setDataPayment: any;
  addNewRow: (index: number) => void;
  removeRow: (index: number) => void;
  handleChange: any;
  isLoading: boolean;
  accountLeadData: any;
  setCompletedSteps: any;
  setCurrentStep: (step: number) => void;
  isDataLoading: boolean;
  setShowPreview: (value: boolean) => void;
  isAddNewCard: boolean;
  setIsAddNewCard: (value: boolean) => void;
  setSavedCardsEmail: (email: string) => void;
  handlePrev: () => void;
  setIsSelectStartDate: (value: boolean) => void;
  show: boolean;
  isRetryPayment: boolean;
  createPayPalIntent: any;
  onUpdatePaymentPlan: (isRetry?: string) => Promise<void>;
  failedPayment: number;
  setShowButtons: (value: boolean) => void;
  showButtons: boolean;
  setIsPreview: (value: boolean) => void;
  handleApplePay: (success: boolean, paymentIntent: any) => Promise<void>;
  isGoogleLoading: boolean;
  handleGooglePay: (tokenData: any, total_amount: any) => Promise<void>;
  isDisabled: boolean;
  setIsDisabled: (value: boolean) => void;
  verifyStripeCardPayment: ({
    intent,
    email,
    error,
    orderId,
    updateMethod,
  }: {
    intent: string | null;
    email: string;
    error: string | null;
    orderId?: number;
    updateMethod: boolean;
  }) => Promise<void>;
  startDate: string;
  setStartDate: (date: string) => void;
  isEndDateError: boolean;
  dateErrMsg: string | null;
  setDateErrMsg: (message: string | null) => void;
  handlePlaidBankPayment: (
    val: any,
    isCCTokenAvailable: boolean
  ) => Promise<void>;
  hasPaymentMethodChanged: boolean;
  hasScheduleChanged: boolean;
  onPaymentMethodChange: (selection: PaymentMethodSelection) => void;
}

const UpdatePlanContent: React.FC<UpdatePlanContentProps> = ({
  initialDisclosureAccept,
  generalMarkers,
  onDisclosureAccept,
  portalSettings,
  ...updateSchedulePaymentProps
}) => {
  const tid = useTid();
  const shouldShowSchedulePayment =
    portalSettings?.state_disclosure_flag === SettingsValue.OFF ||
    initialDisclosureAccept;

  return (
    <>
      {shouldShowSchedulePayment ? (
        <div
          className="contents"
          data-testid={tid("update-plan-schedule-payment")}
          aria-label="Update plan schedule payment"
        >
          <UpdateSchedulePayment {...updateSchedulePaymentProps} />
        </div>
      ) : (
        <div
          className="h-[95%]"
          data-testid={tid("update-plan-initial-disclosure")}
          aria-label="Update plan initial disclosure"
        >
          <DisclosureInitial
            isOpen={true}
            handleAccept={onDisclosureAccept}
            generalMarkers={generalMarkers}
          />
        </div>
      )}
    </>
  );
};

export default UpdatePlanContent;
